import { render, staticRenderFns } from "./Settings_Users.vue?vue&type=template&id=7520a444&scoped=true"
import script from "./Settings_Users.vue?vue&type=script&lang=js"
export * from "./Settings_Users.vue?vue&type=script&lang=js"
import style0 from "./Settings_Users.vue?vue&type=style&index=0&id=7520a444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7520a444",
  null
  
)

export default component.exports